import React, { Component, FiberProvider } from 'react'
import Select from 'react-select';
import * as $ from 'jquery';
import { Navigate } from 'react-router-dom';
// import BinPackCanvas from "./binpackCanvas";
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import {
  CSS2DRenderer,
  CSS2DObject,
} from 'three/examples/jsm/renderers/CSS2DRenderer.js';

import redirectURL from '../redirectURL';
import withRouter from "../withRouter";
// import EdgesHelper from "./edgesHelper";
var initializeDomEvents = require('threex.domevents')
var THREEx = {}

var widgets = [];

// initializeDomEvents(THREE, THREEx)
var bins = [];
var items = [];
const scene = new THREE.Scene();
var itemMap = new Map();

class PreviousPacking3D extends Component {
  constructor(props){
    super(props);
    this.state={
      stackingData:[],
      stackOriginalData:"",
      stacktblbottom:[],
      overlayBlock:"show-n"
    }
    this.loadscene = this.loadscene.bind(this);
    this.loadStackData = this.loadStackData.bind(this);
  }
  componentDidMount = async () =>{
    try{
      var rowid = this.props.params.rowid;
      var p ={
        id : rowid
      }
      redirectURL.post("/dealers/loadstacking",p)
      .then(async (resp) => {
        if(resp.data.status == "success")
        {
          if(resp.data.records.length > 0){
            var params = {
              rownode:resp.data.records[0]
            };
            await redirectURL.post("/dealers/showPrevious3DStackingData",params)
            .then(async (response) => {
              // console.log("response.data ", response.data)
                if(response.data.status == "Success")
                {
                    if(response.data.records.length > 0)
                    {
                        var cnt = response.data.records[0].content;
                    }
                    else{
                        var cnt = "";
                    }
                   
                    await this.setState({
                        stackOriginalData:response.data.records[0].content
                    })
                    await setTimeout(() =>{
                      this.loadStackData();
                    },500)
                    
                }
                else{
                    this.setState({
                        show:true,
                        basicTitle:"Data not found.",
                        basicType:"danger"
                    })
                }
                
            })
          }
        }
        
      })
      
    }
    catch(e){

    }
    
    // await this.loadscene();
  
  }
  // componentWillReceiveProps = async (newprops) =>{
  //   // console.log("newprops ", newprops)
  //   this.setState({
  //     stackOriginalData:newprops.stackOriginalData
  //   })
  //   await this.loadStackData(newprops.stackOriginalData);
  // }
  loadStackData = async(stackOriginalData) =>{
    var stackdata = this.state.stackOriginalData;
    // console.log("stackdata ", stackdata)
    var cnt = stackdata;
    var stackingData = [];
    var tblcontent =[];
    var bottomcontent = [];
    var totvols = 0;
    var totweights = 0;
    try{
        var splittext = cnt.split("#@");
        // console.log("splittext", splittext)
    
        var splitsc = splittext[0].split("#");
        // console.log("splitsc", JSON.stringify(splitsc))
        
        if(splitsc.length > 0)
        {
            splitsc.map((itm) => {
              // console.log("itm ", itm);
                var delim = itm.split(",");
                if(delim.length > 0)
                {
                    try{
                        if(delim[4] != "" && delim[4] != undefined)
                        {
                            var dvol = parseFloat(delim[4])/(1000*1000*1000);
                            var vol = dvol.toFixed(3);
                        }
                        else{
                            var dvol = "";
                            var vol = 0;
                        }
                    }
                    catch(e){
                        
                    }
                    
                    tblcontent.push({
                        sku:delim[0],
                        stack_length:delim[1],
                        stack_width:delim[2],
                        stack_height:delim[3],
                        stack_volume:vol,
                        stack_weight:delim[5],
                        stack_color:delim[7]
                    })
                    var spa=delim[0].split("_");
                    var sp=spa[0].split("-");
                    stackingData.push({
                      sku_ind:parseInt(sp[1]),
                      sku:spa[0],
                      sku_desc:spa[1],
                      width:(parseInt(delim[1])/1000),
                      depth:(parseInt(delim[2])/1000),
                      height:(parseInt(delim[3])/1000),
                      stack_volume:vol,
                      stack_weight:delim[5],
                      color:delim[7],                      
                      Ox:(parseInt(delim[8])).toFixed(2),
                      Oy:(parseInt(delim[9])).toFixed(2),
                      Oz:(parseInt(delim[10])).toFixed(2),
                      x:(parseInt(delim[8])/1000).toFixed(2),
                      y:(parseInt(delim[9])/1000).toFixed(2),
                      z:(parseInt(delim[10])/1000).toFixed(2),
                      orient:(parseInt(delim[11]))

                    })
                    
                    if(delim[5] != "" && delim[5] != undefined)
                    {
                        var weig = delim[5];
                    }
                    else{
                        var weig = 0;
                    }
                    // console.log("Weig", weig);
                    totvols=parseFloat(totvols)+parseFloat(vol);
                    totweights=parseFloat(totweights)+parseFloat(weig);
                }
            })
        }
        if(splittext.length > 0)
        {
            var btm = splittext[1].split("#");
            var btnc = btm[0].split(",");
            if(btnc.length > 0){
                try{
                    if(btnc[4] != "" && btnc[4] != undefined)
                    {
                        var dvol = parseFloat(btnc[4])/(1000*1000*1000);
                        var vol = dvol.toFixed(3);
                    }
                    else{
                        var dvol = "";
                        var vol = 0;
                    }
                }
                catch(e){
                    
                }
                
                bottomcontent.push({
                    truck_type:btnc[0],
                    truck_length:btnc[1],
                    truck_width:btnc[2],
                    truck_height:btnc[3],
                    truck_volume:vol,
                    truck_weight:btnc[5],
                    truck_pallets:btnc[7]
                })
            }
        }
    }
    catch(e){

    }
    try{
        tblcontent.push({
            sku:"Total",
            stack_length:"",
            stack_width:"",
            stack_height:"",
            stack_volume:totvols.toFixed(3),
            stack_weight:totweights.toFixed(3),
            stack_color:""
        })
    }
    catch(e){}
    // console.log('stackingData ', stackingData)
    this.setState({
        stackingData : stackingData,
        stacktblbottom:bottomcontent,
        overlayBlock:"show-n"
    });
    await setTimeout(() => {
      this.loadscene();
    })
    
  }
  
  loadscene(){
    
    var bottomcontent = this.state.stacktblbottom;
    var h = 564;
    var w = 1281;
    var fov = 35;
    var imaps =  new Map();

    const { innerWidth, innerHeight } = window;
    const labelRenderer = new CSS2DRenderer();
    labelRenderer.setSize(innerWidth, innerHeight);
    labelRenderer.domElement.style.position = 'absolute';
    labelRenderer.domElement.style.top = '0px';
    labelRenderer.domElement.style.pointerEvents = 'none';
    document.body.appendChild(labelRenderer.domElement);

    var scene = new THREE.Scene();
    if(this.state.stacktblbottom.length > 0)
    {
      //Assigning Length, Height and Depth values to variables.
      var container_width_px = this.state.stacktblbottom[0].truck_length;
      var container_width_cm = (this.state.stacktblbottom[0].truck_length/1000);
      var container_height_px = this.state.stacktblbottom[0].truck_height;
      var container_height_cm = this.state.stacktblbottom[0].truck_height/1000;
      var container_depth_px = this.state.stacktblbottom[0].truck_width;
      var container_depth_cm = this.state.stacktblbottom[0].truck_width/1000;
      
    }
    else{
      var container_width_px = 10000;
      var container_width_cm = 9600/1000;
      var container_height_px = 2400;
      var container_height_cm = 2400/1000;
      var container_depth_px = 2400;
      var container_depth_cm = 2400/1000;
      
    }
    
    const canvas = document.querySelector('#sceneAppend');
    //To get the Ratio value of the window.
    var ratio = window.innerWidth/window.innerHeight;
    // var camera = new THREE.PerspectiveCamera(70,ratio,5,100);
    //Creteing a Camera 
    var camera = new THREE.PerspectiveCamera( fov, ratio, 1, 10000);
    
    camera.position.x = 0;
    camera.position.y = 3;
    camera.position.z = -10;

    //Get the Div element to append scene , camera, etc.,
    // //Displaying box with transparent backgorund
    const renderer = new THREE.WebGLRenderer( { alpha: true } );
    renderer.setPixelRatio( window.devicePixelRatio );
    renderer.setSize( window.innerWidth, window.innerHeight );
    document.body.appendChild( renderer.domElement );
    // document.getElementById("sceneAppend").appendChild( renderer.domElement )

    //Applying the color to the box skeleton
    var material = new THREE.MeshBasicMaterial({color: 0xff0000, wireframe:true});
    
    // Create Box View 
    var geometry = new THREE.BoxGeometry(container_width_cm,container_height_cm,container_depth_cm);
    //Creating box edges and apply color
    var edges = new THREE.EdgesGeometry(geometry);
    var lines = new THREE.LineSegments(edges, new THREE.LineBasicMaterial( { color: 0xff0000 } ));
    var cube = new THREE.Mesh(geometry,material);
    cube.userData.name = "box";
    // Append lines to scene
    scene.add(cube);
    // scene.add(lines);

    // const light = new THREE.AmbientLight( 0x404040 ); // soft white light
    // scene.add( light );

    // const light = new THREE.HemisphereLight( 0xffffbb, 0x080820, 1 );
    // scene.add( light );
    const light = new THREE.DirectionalLight( 0xffffff, 1 );
    light.position.set( 1, 1, 1 ).normalize();
    scene.add( light );


    //Set up shadow properties for the light
    light.shadow.mapSize.width = container_width_cm; // default
    light.shadow.mapSize.height = container_height_cm; // default
    light.shadow.camera.near = 0.5; // default
    light.shadow.camera.far = 1000; // default

    // const lightd = new THREE.DirectionalLight( 0xffffff, 1 );
    // // lightd.position.set( 1, 1, 1 ).normalize();
    // scene.add( lightd );
  

    var controls =  new OrbitControls(camera, renderer.domElement);
    controls.target.set(0,0,0);
    controls.enableDamping = true;
    
    // var controls = new DragControls( [ ... objects ], camera, renderer.domElement );
    // controls.addEventListener( 'drag', render );
    controls.update();


    const labelDiv = document.createElement('div');
    labelDiv.className = 'label';
    labelDiv.style.marginTop = '-1em';
    const label = new CSS2DObject(labelDiv);
    label.visible = false;
    scene.add(label);

    var cubes = [];
    var objects = [];
    var clights = [];
    var edges = [];
    const smgeometry = new THREE.BoxGeometry( container_width_cm,container_height_cm,container_depth_cm );
    var items = this.state.stackingData;
    for (var i = 0; i < items.length; i++) {
      
      // console.log("items : ", items[i])
      // console.log("items ", items[i].orient)

      // D=height=depth
      // H=width=width
      // W=depth=length

      var mywid = items[i].width;
      var myhigh = items[i].height;
      var mydep = items[i].depth;
      if(parseInt(items[i].orient) == 0)
      {
        // RT_WHD = 0
        mywid = items[i].width;
        myhigh = items[i].height;
        mydep = items[i].depth;
      }
      if(parseInt(items[i].orient) == 1)
      {
        // RT_HWD = 1
        mywid = items[i].depth;
        myhigh = items[i].height;
        mydep = items[i].width;
      }
      if(parseInt(items[i].orient) == 2)
      {
        // RT_HDW = 2
        // console.log("orient 2", items[i])
        mywid = items[i].depth;
        myhigh = items[i].width;
        mydep = items[i].height;


      }
      if(parseInt(items[i].orient) == 3)
      {
        // RT_DHW = 3
        // console.log("orient 3", items[i])
        mywid = items[i].height;
        myhigh = items[i].width;
        mydep = items[i].depth;
      }
      if(parseInt(items[i].orient) == 4)
      {
        // RT_DWH = 4
        // console.log("orient 4", items[i])
        mywid = items[i].height;
        myhigh = items[i].depth;
        mydep = items[i].width;
      }
      if(parseInt(items[i].orient) == 5)
      {
        // RT_WDH = 5
        // console.log("orient 5", items[i].sku)
        mywid = items[i].depth;
        myhigh = items[i].width;
        mydep = items[i].height;
      }
      var geometryi = new THREE.BoxBufferGeometry( mywid,myhigh, mydep);
      var materiali = new THREE.MeshBasicMaterial({color:items[i].color});
      var cubei = new THREE.Mesh(geometryi, materiali);
      materiali.userData.rownode = items[i];

      var pos = positionWithPivotNeg(items[i].x, (items[i].z), (items[i].y), mywid,myhigh, mydep, items[i].orient);
      // console.log("pos ", pos)
      // console.log("items[i].sku ", items[i].sku)
      cubei.position.x = parseFloat(pos.x);
      cubei.position.y = parseFloat(pos.y);
      cubei.position.z = parseFloat(pos.z);
      // cubei.position.x = -2.665;
      // cubei.position.y = -0.6499999999999999;
      // cubei.position.z = 0.63;

      cubei.userData.rownode = items[i];
      cubes.push(cubei);

      scene.add( cubei );

      imaps.set(materiali,items[i]);
      
      objects.push(cubei);
      items[i].graphicsItem = cubei;
      // imaps.set(cube, items[i]);

      var edgei = new THREE.EdgesGeometry(cubei.geometry);
      var linei = new THREE.LineSegments(edgei, new THREE.LineBasicMaterial({color: 0x000000, lineWidth:30 }));
      
      linei.position.x = pos.x;
      linei.position.y = pos.y;
      linei.position.z = pos.z;
      linei.userData.rownode = items[i];
      edges.push(linei);
      scene.add(linei);
      
      // scene.add(cubei);

      // const colr = items[i].color;
      const intensity = 1;
         
     const skyColor = 0xB1E1FF;  // light blue
     var groundColor = items[i].color;  // brownish orange
    //  var ilight = new THREE.HemisphereLight(skyColor, groundColor, intensity);
    //  ilight.position.set( 1, 1, 1 ).normalize();
    //  clights.push(ilight);

     const ilight = new THREE.DirectionalLight( 0xffffff, 1 );
     ilight.position.set( 1, 1, 1 ).normalize();
     scene.add( ilight );


    }
    
    // var axis = new THREE.AxesHelper(5);
    // scene.add(axis);

    function positionWithPivotNeg(x, y, z, width, height, depth, orient) {
      // console.log("Neg pos ", x+"____"+y+"____"+z+"_____"+width+"_____"+height+"_____"+depth+"_____containerWidth===="+container_width_cm+"_____containerHeight===="+container_height_cm+"_____containerDepth===="+container_depth_cm)
      // console.log("orientorient ", orient)
      // if(orient == 0)
      // {
        var newPosition = {
          x: parseFloat(x)+(parseFloat(width)/2.0)-(parseFloat(container_width_cm)/2.0),
          y: parseFloat(y)+(parseFloat(height)/2.0)-(parseFloat(container_height_cm)/2.0),
          z: parseFloat(z)+(((parseFloat(depth)/2.0)-(parseFloat(container_depth_cm)/2.0)))
          
        };
      // }
      // else if(orient == 1)
      // {
      //   var newPosition = {
      //     x: parseFloat(x)+(parseFloat(width)/2.0)-(parseFloat(container_width_cm)/2.0),
      //     y: parseFloat(y)+(parseFloat(height)/2.0)-(parseFloat(container_height_cm)/2.0),
      //     z: (((parseFloat(container_depth_cm)/2.0)+(parseFloat(depth)/2.0))/2)+0.2-parseFloat(z)
          
      //   };
      // }
      // else if(orient == 2)
      // {
      //   var newPosition = {
      //     x: parseFloat(x)+(parseFloat(width)/2.0)-(parseFloat(container_width_cm)/2.0),
      //     y: parseFloat(y)+(parseFloat(height)/2.0)-(parseFloat(container_height_cm)/2.0),
      //     z: (((parseFloat(container_depth_cm)/2.0)+(parseFloat(depth)/2.0))/2)+0.52-parseFloat(z)
          
      //   };
      // }
      // else if(orient == 3)
      // {
      //   var newPosition = {
      //     x: parseFloat(x)+(parseFloat(width)/2.0)-(parseFloat(container_width_cm)/2.0),
      //     y: parseFloat(y)+(parseFloat(height)/2.0)-(parseFloat(container_height_cm)/2.0),
      //     z: (((parseFloat(container_depth_cm)/2.0)+(parseFloat(depth)/2.0))/2)+0.2-parseFloat(z)
          
      //   };
      // }
      // else if(orient == 4)
      // {
      //   var newPosition = {
      //     x: parseFloat(x)+(parseFloat(width)/2.0)-(parseFloat(container_width_cm)/2.0),
      //     y: parseFloat(y)+(parseFloat(height)/2.0)-(parseFloat(container_height_cm)/2.0),
      //     z: (((parseFloat(container_depth_cm)/2.0)+(parseFloat(depth)/2.0))/2)-parseFloat(z)
          
      //   };
      // }
      // else if(orient == 5)
      // {
      //   var newPosition = {
      //     x: parseFloat(x)+(parseFloat(width)/2.0)-(parseFloat(container_width_cm)/2.0),
      //     y: parseFloat(y)+(parseFloat(height)/2.0)-(parseFloat(container_height_cm)/2.0),
      //     z: (((parseFloat(container_depth_cm)/2.0)+(parseFloat(depth)/2.0))/2)-parseFloat(z)
          
      //   };
      // }
      // else{
      //   var newPosition = {
      //     // x: x/2 -(width/2),
      //     // y: y/2 -(height/2),
      //     // z: z/2 -(depth/2)

      //     // x: (container_width_cm/2.0)-(width/2.0)-x,
      //     // y: y-(container_height_cm/2.0)+(height/2.0),
      //     // z: ((container_depth_cm/2.0)+(depth/2.0))/2+0.2-z

          
      //     x: parseFloat(x)+(parseFloat(width)/2.0)-(parseFloat(container_width_cm)/2.0),
      //     y: parseFloat(y)+(parseFloat(height)/2.0)-(parseFloat(container_height_cm)/2.0),
      //     z: (  ((parseFloat(container_depth_cm)/2.0)+(parseFloat(depth)/2.0))/2)-parseFloat(z)
          
      //   };
      // }
      // console.log("newPosition ", newPosition)
      return newPosition;
    }

    const raycaster = new THREE.Raycaster();
    // raycaster.ray.origin.x = 0;
    // raycaster.ray.origin.y = 0;
    // raycaster.ray.origin.z = 0;

    // raycaster.ray.direction.x = container_width_cm/2;
    // raycaster.ray.direction.y = container_height_cm/2;
    // raycaster.ray.direction.z = container_depth_cm/2;
    // let arrowray = new THREE.ArrowHelper(raycaster.ray.direction,camera.position, 10, 0Xff0000);
    // scene.add(arrowray);
    const pointer = new THREE.Vector2();

     function resizeRendererToDisplaySize(renderer) {
      const canvas = renderer.domElement;
      const width = canvas.clientWidth;
      const height = canvas.clientHeight;
      const needResize = canvas.width !== width || canvas.height !== height;
      if (needResize) {
        renderer.setSize(width, height, false);
      }
      return needResize;
    }
  
    let theta = 0;
    let INTERSECTED;
    let renderRequested = false;
    let selected;
    function render() {
      renderRequested = undefined;
  
      // if(selected != undefined)
      // {
      //   selected.rotation.x += 0.01
      // }
      if (resizeRendererToDisplaySize(renderer)) {
        const canvas = renderer.domElement;
        camera.aspect = canvas.clientWidth / canvas.clientHeight;
        camera.updateProjectionMatrix();
      }
      controls.update();
      
      // arrowray.setDirection(raycaster.ray.direction);
      
      renderer.render(scene, camera);
    }
    render();
  
    function requestRenderIfNotRequested() {
      if (!renderRequested) {
        renderRequested = true;
        requestAnimationFrame(render);
        
				camera.updateProjectionMatrix();
      }
    }
     
    function onMouseDown( event ) {
      // console.log("event ", event)
      // event.preventDefault();
      // calculate pointer position in normalized device coordinates
      // (-1 to +1) for both components

      pointer.x = (event.clientX / (window.innerWidth)) * 2 - 1;
      pointer.y = -(event.clientY / (window.innerHeight)) * 2 + 1;
      // console.log("pointer.x ", pointer.x)
      raycaster.setFromCamera( pointer, camera );

      const intersects = raycaster.intersectObjects( objects, true );

      if ( intersects.length > 0 ) {

        if ( INTERSECTED != intersects[ 0 ].object ) {

          INTERSECTED = intersects[ 0 ].object;
          
          // INTERSECTED.currentHex = INTERSECTED.material.emissive.getHex();
          // INTERSECTED.material.color.setHex( 0xff0000 );
         

        }

      } else {

        // if ( INTERSECTED ) INTERSECTED.material.color.set( 0xff0000 );

        INTERSECTED = null;

      }

    }
    
    
    controls.addEventListener('change', requestRenderIfNotRequested);
    window.addEventListener('resize', requestRenderIfNotRequested);
    window.addEventListener( 'mousedown', onMouseDown );
    window.addEventListener( 'click', async ()=>{
        // console.log("Test ", INTERSECTED);
        if(INTERSECTED != null)
        {
          if(INTERSECTED.userData.rownode != undefined)
          {
            var data = INTERSECTED.userData.rownode;
            document.querySelector('#itemBox').innerHTML="";
            // setTimeout(() =>{
            // window.loadLoader(data);
            // },500)
            // INTERSECTED.material.color.set( "#"+data.color );
            // console.log('bottomcontent ',bottomcontent)
            var html ="<div class='col-sm-12 border1-white ' ><span class='dinf f16'>Details:</span> <span style='float:right;margin-right:40px;font-family:arial;'>Vehicle Volume (CMT): "+bottomcontent[0].truck_volume+"<span style='margin-left:40px;margin-right:40px;font-family:arial;'>Vehicle Weight (Kgs): "+bottomcontent[0].truck_weight+"</span></span></div><div class='col-sm-3 border1-white'><b>SKU:</b><br /> "+data.sku+"</div>";
            html +="<div class='col-sm-3 border1-white'><b>Description:</b> <br />"+data.sku_desc+"</div>";
            html +="<div class='col-sm-3 border1-white'><b>Length:</b> "+(data.width*1000)+"";
            html +="&nbsp;&nbsp;&nbsp;&nbsp;<b>Width:</b> "+(data.depth*1000)+"";
            html +="<br /><b>Height:</b> "+(data.height*1000)+"</div>";
            html +="<div class='col-sm-3 border1-white'><b>Volume (CMT): </b> "+(data.stack_volume*1000*1000*1000)+"";
            html +="<br /><b>Weight (Kgs): </b> "+data.stack_weight+"</div>";            
            // html +="Color: "+data.color+"<br />";
            // html +="X: "+data.Ox+"<br />";
            // html +="Y: "+data.Oy+"<br />";
            // html +="Z: "+data.Oz+"<br />";
            // html +="X-Axis: "+data.x+"<br />";
            // html +="Y-Axis: "+data.y+"<br />";
            // html +="Z-Axis: "+data.z+"<br />";
            // html +="Orient: "+data.orient+"<br />";
            document.getElementById("box_details").innerHTML=html;
            selected = INTERSECTED;
            
          }
        }
    });
    renderer.domElement.addEventListener( 'webglcontextlost', function() {
        window.location.reload();
    });
    renderer.render(scene, camera);
    



  }

  hideSlideBlock(){
    this.setState({
        // overlayBlock:"show-n",
        // showSlideBlock:"",
        // showSlideBlockUpload:"",
        // showSlideBlockRoute:"",
        // showSlideBlockStack:"",
    })
  }

  
  render() {
    return (
      <div className="container-fluid" id="sceneAppend" >
        <div className="row">
            <div className="col-sm-8" id="continr">
              <div id="sceneAppend1" ref={this.sceneAppend} className="packwidget"></div>
            </div>
            
            <div className="col-sm-4">
            <div id="itemBox" style={{position:"fixed",top:"0",left:"7.3%",width:"190px", height:"125px"}}>
                
              </div>
            <div style={{position:"fixed",top:"-20px", left:"19.8%",overflowY:"auto",maxHeight:"170px",padding:"20px",fontSize:"15px",color:"#000",width:"70%",height:"170px",lineHeight:"30px",overflow:"hidden"}}>
              
              <div className="row" id="box_details" style={{border:"1px solid #333",overflow:"hidden"}}>
                </div>
            </div>
            

            </div>

          </div>
          <div className={"overlay-block "+(this.state.overlayBlock)} onClick={this.hideSlideBlock.bind(this)}></div>
       
 
    </div>
    )
  }
}

function GetSortAscOrder(prop) {    
  return function(a, b) {    
      if (a[prop] > b[prop]) {    
          return 1;    
      } else if (a[prop] < b[prop]) {    
          return -1;    
      }    
      return 0;    
  }    
} 

function GetSortDescOrder(prop) {    
  return function(a, b) {    
      if (a[prop] < b[prop]) {    
          return 1;    
      } else if (a[prop] > b[prop]) {    
          return -1;    
      }    
      return 0;    
  }    
} 






export default withRouter(PreviousPacking3D) ;